<template>
  <div>
    <h3 class="header-title">Learning Student</h3>
    <label>Let’s see your tuition student.</label>
    <br />
    <label>
      You have subscribed to the {{ user.packageName }} package, which is valid
      until {{ user.validTo }}. This subscription comes at a price of {{ user.currencyCode}} 
      {{ user.invoiceprice }} and includes a limit of
      {{ check.NumberOfStudent }} students and
      <span v-if="check.TotalTeacher === 0">Unlimited</span
      ><span v-else>{{ check.TotalTeacher }} </span> teachers.
    </label>
    <br />
    <div class="custom-explore">
      <div>
        <CRow>
          <CCol sm="12">
            <div style="width: 80%" class="float-left">
              <img
                src="../assets/img/iconnoti.svg"
                class="ml-5 mr-2 mb-3 mt-3"
              />
              <span class="text-white mt-3 mb-2"> | </span>
              <label class="ml-2 text-white mt-3 mb-2"
                >Explore more on your student !</label
              >
            </div>
            <div style="width: 20%" class="float-right p-0">
              <br /><br />
              <img
                src="../assets/img/icontriangle.svg"
                class="ml-5 mr-2"
                style="
                  position: absolute;
                  top: 0;
                  right: 100px;
                  bottom: 0;
                  height: 55px;
                "
              />
            </div>
          </CCol>
        </CRow>
      </div>
    </div>
    <div v-if="user.validTo < currentDate" class="mt-2">
      <CAlert show color="danger">
        <CRow>
          <CCol sm="10">
            <strong class="text-danger mr-2"
              >X ERROR ! Your subscription package has expired. Please renew
              your current subscription or upgrade to a new package.
            </strong>
          </CCol>
          <CCol sm="2" class="text-right">
            <CButton type="button" class="custom-btn-navy" @click="GoToRenew()"
              >Renew</CButton
            >
          </CCol>
        </CRow>
      </CAlert>
    </div>

    <!-- Search Input -->
    <CRow>
      <CCol sm="10">
        <div class="search-container mt-3">
  <input
    type="text"
    v-model="searchQuery"
    placeholder="Search students..."
  />

</div>
<CButton class="mb-3" color="success" @click="downloadCSV">
  Download CSV
</CButton>
      </CCol>
      <CCol sm="2">  <CButton @click="onSearch" class="mt-3 bg-gradient-blue">Search</CButton></CCol>
    </CRow>
   

    <!-- Page Size Selector -->
 

    <div v-if="Busy">Loading...</div>
  
    <div class="d-flex align-items-center mb-2">
  <CSwitch
    variant="3d"
    color="primary"
    size="sm"
    class="mt-2"
    type="checkbox"
    name="showAllStatuses"
    :checked="showAllStatuses"
    @update:checked="(val) => {
      showAllStatuses = val; 
      radio = val; 
    }"
  />
  <label class="ml-2 mb-0 mt-2">Toggle to display all students, including inactive ones.</label>
</div>
    <CRow>
      <CCol sm="9">
        <div v-if="!Busy && totalPages > 1" class="pagination">
      <!-- First Button -->
      <button :disabled="currentPage === 1" @click="GetStudent(1)">First</button>
      
      <!-- Previous Button -->
      <button :disabled="currentPage === 1" @click="GetStudent(currentPage - 1)"><</button>
      
      <!-- Display page numbers with only a limited range -->
      <button v-for="page in visiblePageNumbers" :key="page" @click="GetStudent(page)" :class="{ active: page === currentPage }">
        {{ page }}
      </button>
      
      <!-- Next Button -->
      <button :disabled="currentPage === totalPages" @click="GetStudent(currentPage + 1)">></button>
      
      <!-- Last Button -->
      <button :disabled="currentPage === totalPages" @click="GetStudent(totalPages)">Last</button>
    </div>
      </CCol>
      <CCol sm="3">
        <div class="page-size-selector">
      <label for="pageSize">Show</label>
      <select v-model="pageSize" @change="onPageSizeChange">
        <option :value="5">5</option>
        <option :value="10">10</option>
        <option :value="50">50</option>
        <option :value="100">100</option>
      </select>
      <span>entries per page</span>
    </div>
      </CCol>
    </CRow>

   <br />
    <table v-if="!Busy && students.length > 0" class="table-responsive-sm styled-table">
      <thead>
        <tr>
          <th>ID</th>
          <th>Name</th>
          <th>Packages</th>
          <th>Subject</th>
          <th>Cost</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody class="">
        <tr v-for="student in students" :key="student.Id">
          <td>{{ student.Id }} 
           </td>
          <td> 
            <CRow>
              <CCol sm="2">
                <img
                v-if="student.profileImagePath == null"
                style="
                  border: 1px solid #eee;
                  width: 50px;
                  height: 50px;
                  border-radius: 50%;
                  object-fit: cover;
                "
                src="../assets/img/default.png"
                class="grey lighten-2 mt-2"
              />

              <img
                v-else
                style="
                  border: 3px solid #ddd;
                  background: #fff;
                  width: 50px;
                  height: 50px;
                  border-radius: 50%;
                  object-fit: cover;
                "
                :src="getPicChild(student)"
                class="grey lighten-2 mt-2"
              />
              </CCol>
              <CCol sm="10">
                <div class="mt-2">{{ student.Name }}</div>
            <CBadge v-if="student.Status == 'active'" color="success"
                >Active</CBadge
              >
              <CBadge v-else-if="student.Status == 'inactive'" color="danger"
                >InActive</CBadge
              >
              <CBadge v-else color="warning"></CBadge>
              </CCol>
            </CRow> 
            
              <div class="small text-muted mt-1">
                Parent Name : {{ student.ParentName }} / {{ student.ParentEmail }}
              </div>
              <div class="small text-muted">Grade : {{ student.Grade }}</div>
              <div class="small text-muted">Class : {{ student.Class }}</div>
              <div class="small text-muted">Parent H/P : {{ student.Phone }}</div>
              <div class="small text-muted">
                Registered : {{ student.DateRegister }}
              </div>
              <div class="small text-muted">
                <CBadge
                  color="warning"
                  class="ml-auto"
                  v-if="student.Rate == 'monthly'"
                  >{{ student.Rate }}</CBadge
                >
                <CBadge color="info" class="ml-auto" v-else>{{
                  student.Rate
                }}</CBadge>
              </div>
          </td>
          <td>
            <div v-if="student.Packages.length > 0">
                <ul v-for="packages in student.Packages" :key="packages.Id" class="p-0">
                  <!-- <img src="../assets/img/list.png" width="15px" class="mr-2"/>     -->
                   <li> {{ packages.Name }} - RM {{ packages.StudentFee }} </li>
                  <!-- <ul v-if="packages.Subjects.length > 0">
                    <li v-for="subject in packages.Subjects" :key="subject.Id">
                      <i>{{ subject.Name }}</i> (Teacher: {{ subject.Teacher }})
                    </li>
                  </ul> -->
                </ul>
            </div>
            <span v-else>
              <div class="text-left text-danger">
                <img src="../assets/img/nosubs.png" width="15px" class="mr-2"/>No packages</div></span>
          </td>
          <td>
            <ul>
              <div v-if="student.Packages.length > 0">
                <ul v-for="packages in student.Packages" :key="packages.Id" class="p-0">
                  <div v-if="packages.Subjects.length > 0">
                    <li v-for="subject in packages.Subjects" :key="subject.Id">
                      {{ subject.Name }}
                      <div class="small text-muted">
                        (Teacher: {{ subject.Teacher }})
              </div>
            </li>
                  </div>
                </ul>
                </div>
                <span v-else>
              <div class="text-left text-danger">
                <img src="../assets/img/nosubs.png" width="15px" class="mr-2"/>No subject</div></span>

              </ul>
             
          </td>
          <td>
            Discount:<br />
            <strong style="color: #1e109c">
              <span v-if="student.Discount == null">{{ student.currencyCode}}  0</span>
              <span v-else>{{ user.currencyCode}} {{ student.Discount }}</span>
            </strong>
            <br /><br />
            Total Fee:<br />
            <strong style="color: #1e109c">
              {{ user.currencyCode}}  {{ student.TotalFee - student.Discount }}
            </strong>
          </td>
          <td>
            <CDropdown
              toggler-text="Action"
              class="m-2 btn-act"
            >
              <CDropdownItem @click="OpenStudentModal(student)">Detail Student</CDropdownItem>
              <CDropdownItem @click="OpenDiscountModal(student)">Add Discount</CDropdownItem>
              <CDropdownItem @click="OpenAssignPackageModal(student)">Assign Package</CDropdownItem>
              <hr />
              <CDropdownItem @click="OpenUpdateStudent(student)">Edit Student</CDropdownItem>
              <CDropdownItem @click="OpenInactiveModal(student)">Delete Student</CDropdownItem>
            </CDropdown>
          </td>
        </tr>
      </tbody>
    </table>

    <div v-if="students.length === 0 && !Busy">No students found.</div>

    <!-- Pagination Controls -->
    <div v-if="!Busy && totalPages > 1" class="pagination">
      <!-- First Button -->
      <button :disabled="currentPage === 1" @click="GetStudent(1)">First</button>
      
      <!-- Previous Button -->
      <button :disabled="currentPage === 1" @click="GetStudent(currentPage - 1)"><</button>
      
      <!-- Display page numbers with only a limited range -->
      <button v-for="page in visiblePageNumbers" :key="page" @click="GetStudent(page)" :class="{ active: page === currentPage }">
        {{ page }}
      </button>
      
      <!-- Next Button -->
      <button :disabled="currentPage === totalPages" @click="GetStudent(currentPage + 1)">></button>
      
      <!-- Last Button -->
      <button :disabled="currentPage === totalPages" @click="GetStudent(totalPages)">Last</button>
    </div>

    <br />


    <div v-if="StudentDetailModal" class="popup-all backdrop-all">
        <div class="popup-all1 p-4">
            <CRow class="align-items-center mb-3">

                <div style="width:100%" class="text-right">
                    <img src="../assets/img/close.png" style="max-width: 30px; cursor: pointer;" @click="closePopupStudent" />
                </div>
            </CRow>
            
            <CRow
            v-for="item in studentDetails.StudentRegInfo.length > 0 ? studentDetails.StudentRegInfo : [studentDetails]"
            v-bind:key="item.Id"
          >
            <CCol sm="12">
              <CForm>
                <fieldset>
                  <legend>Student Detail</legend>

                  <CRow class="p-1">
                    <CCol sm="4"> <label>Student Name</label></CCol>
                    <CCol sm="8">
                      <label>
                        <strong class="font-weight-700">
                          : {{ item.FullName || studentDetails.Name }}
                        </strong>
                      </label>
                    </CCol>

                    <CCol sm="4"> <label>Status</label></CCol>
                    <CCol sm="8">
                      <label>
                        <strong class="font-weight-700">
                          : {{ item.Status || studentDetails.Status }}
                        </strong>
                      </label>
                    </CCol>

                    <CCol sm="4"> <label>IC Number</label></CCol>
                    <CCol sm="8">
                      <label>
                        <strong class="font-weight-700">
                          : {{ item.IdentityCertificateNumber || "N/A" }}
                        </strong>
                      </label>
                    </CCol>

                    <CCol sm="4"> <label>Gender</label></CCol>
                    <CCol sm="8">
                      <label>
                        <strong class="font-weight-700">
                          : {{ item.Gender || "N/A" }}
                        </strong>
                      </label>
                    </CCol>

                    <CCol sm="4"> <label>Birth Date</label></CCol>
                    <CCol sm="8">
                      <label>
                        <strong class="font-weight-700">
                          : {{ item.BirthDate || "N/A" }}
                        </strong>
                      </label>
                    </CCol>

                    <CCol sm="4"> <label>Student Class</label></CCol>
                    <CCol sm="8">
                      <label>
                        <strong class="font-weight-700">
                          : {{ item.Class || studentDetails.Class || "N/A" }}
                        </strong>
                      </label>
                    </CCol>

                    <CCol sm="4"> <label>Student Grade</label></CCol>
                    <CCol sm="8">
                      <label>
                        <strong class="font-weight-700">
                          : {{ item.Grade || studentDetails.Grade || "N/A" }}
                        </strong>
                      </label>
                    </CCol>

                    <CCol sm="4"> <label>Age</label></CCol>
                    <CCol sm="8">
                      <label>
                        <strong class="font-weight-700">
                          : {{ item.Age || "N/A" }}
                        </strong>
                      </label>
                    </CCol>

                    <CCol sm="4"> <label>Package Interest</label></CCol>
                    <CCol sm="8">
                      <label>
                        <strong class="font-weight-700">
                          : {{ item.PackageInterest || "N/A" }}
                        </strong>
                      </label>
                    </CCol>

                    <CCol sm="4"> <label>Allergy</label></CCol>
                    <CCol sm="8">
                      <label>
                        <strong class="font-weight-700">
                          : {{ item.FoodAllergy || "None" }}
                        </strong>
                      </label>
                    </CCol>

                    <CCol sm="4"> <label>Facebook</label></CCol>
                    <CCol sm="8">
                      <label>
                        <strong class="font-weight-700">
                          : {{ item.Facebook || "N/A" }}
                        </strong>
                      </label>
                    </CCol>
                  </CRow>
                </fieldset>
                <br />
                <fieldset>
                  <legend>Parent Detail</legend>

                  <CRow class="p-1">
                    <CCol sm="4"> <label>Parent Name</label></CCol>
                    <CCol sm="8">
                      <label>
                        <strong class="font-weight-700">
                          : {{ item.ParentName || studentDetails.ParentName }}
                        </strong>
                      </label>
                    </CCol>

                    <CCol sm="4"> <label>Parent Email</label></CCol>
                    <CCol sm="8">
                      <label>
                        <strong class="font-weight-700">
                          : {{ item.ParentEmail || studentDetails.ParentEmail }}
                        </strong>
                      </label>
                    </CCol>

                    <CCol sm="4"> <label>Parent Phone</label></CCol>
                    <CCol sm="8">
                      <label>
                        <strong class="font-weight-700">
                          : {{ item.ParentPhoneNumber || studentDetails.ParentPhoneNumber }}
                        </strong>
                      </label>
                    </CCol>

                    <CCol sm="4"> <label>Main Contact</label></CCol>
                    <CCol sm="8">
                      <label>
                        <strong class="font-weight-700">
                          : {{ item.MainContactNumber || "N/A" }}
                        </strong>
                      </label>
                    </CCol>

                    <CCol sm="4"> <label>Occupation</label></CCol>
                    <CCol sm="8">
                      <label>
                        <strong class="font-weight-700">
                          : {{ item.Occupation || "N/A" }}
                        </strong>
                      </label>
                    </CCol>

                    <CCol sm="4"> <label>State</label></CCol>
                    <CCol sm="8">
                      <label>
                        <strong class="font-weight-700">
                          : {{ item.State || "N/A" }}
                        </strong>
                      </label>
                    </CCol>

                    <CCol sm="4"> <label>Father Phone</label></CCol>
                    <CCol sm="8">
                      <label>
                        <strong class="font-weight-700">
                          : {{ item.FatherPhoneNumber || "N/A" }}
                        </strong>
                      </label>
                    </CCol>

                    <CCol sm="4"> <label>Zip Code</label></CCol>
                    <CCol sm="8">
                      <label>
                        <strong class="font-weight-700">
                          : {{ item.ZipCode || "N/A" }}
                        </strong>
                      </label>
                    </CCol>

                    <CCol sm="4"> <label>School Name</label></CCol>
                    <CCol sm="8">
                      <label>
                        <strong class="font-weight-700">
                          : {{ item.SchoolName || "N/A" }}
                        </strong>
                      </label>
                    </CCol>

                    <CCol sm="4"> <label>Remark</label></CCol>
                    <CCol sm="8">
                      <label>
                        <strong class="font-weight-700">
                          : {{ item.Remarks || "N/A" }}
                        </strong>
                      </label>
                    </CCol>
                  </CRow>
                </fieldset>
              </CForm>
            </CCol>
          </CRow>
        </div>
    </div>


    <div v-if="DiscountModal" class="popup-all backdrop-all">
        <div class="popup-all1 p-4">
            <CRow class="align-items-center mb-3">

                <div style="width:100%" class="text-right">
                    <img src="../assets/img/close.png" style="max-width: 30px; cursor: pointer;" @click="closePopupDiscount" />
                </div>
            </CRow>
            <CRow>
                <CCol sm="4"> <label>Student Name</label>
                </CCol>
                <CCol sm="8">
                  <label>
                    <strong class="font-weight-700">
                      : {{ studentDetails.Name }}
                    </strong>
                  </label>
                </CCol>

                <CCol sm="4"> <label>Email</label>
                </CCol>
                <CCol sm="8">
                  <label>
                    <strong class="font-weight-700">
                      : {{ studentDetails.StudentEmail }}
                    </strong>
                  </label>
                </CCol>


              
                <br />
                <CCol sm="12">
                  <CRow>
                    <CCol sm="12">  <h6 class="mt-2"><strong>FORM DISCOUNT</strong></h6></CCol>
                    <CCol sm="3"> Discount </CCol>
                    <CCol sm="9">
                      <CInput type="text" v-model="Discount" />
                    </CCol>
                    <CCol sm="12"> <CButton
                  type="submit"
                  class="p-2"
                  color="info"
                  @click="UpdateDiscount(studentDetails.Id)"
                  >Proceed</CButton
                ></CCol>
                  </CRow>
                </CCol>
               
            </CRow>
        </div>
    </div>

    <div v-if="AssignPackageModal" class="popup-all backdrop-all">
        <div class="popup-all1 p-4">
            <CRow class="align-items-center mb-3">

                <div style="width:100%" class="text-right">
                    <img src="../assets/img/close.png" style="max-width: 30px; cursor: pointer;" @click="closePopupPackage" />
                </div>
            </CRow>
            <CRow>
              <CCol sm="12">
                Student Name: {{ studentDetails.Name }}
          <br />
          Email: {{ studentDetails.StudentEmail }} <br />
          Parent Email: {{ studentDetails.ParentEmail }} <br />
          <br />
              </CCol>
        
          <CCol sm="12">
            <h6><strong>ADD ASSIGN PACKAGE</strong></h6>
          </CCol>
         
          <br />
          <CCol sm="12">
            <CRow>
              <CCol sm="4"> Package </CCol>
              <CCol sm="8">
                <v-select
                  v-model="selectedPackage"
                  :options="packages"
                  label="Name"
                  placeholder="--Please Select Package--"
                ></v-select>
              </CCol>
            </CRow>
          </CCol>

          <br />

          <CCol sm="12">
            <h6><strong>REMOVE PACKAGE</strong></h6>
          </CCol>
         
          <br />
          <div style="clear: both"></div>
          <CCol sm="12">
            <CDataTable
              :small="small"
              :fixed="fixed"
              :items="studentpackages"
              :fields="fieldsPackages"
              items-per-page-select
              :items-per-page="small ? 5 : 5"
              clickable-rows
              pagination
              table-filter
            >
              <template #Name="{ item }">
                <td>
                  {{ item.Name }}
                </td>
              </template>
              <template #Action="{ item }">
                <td>
                  <CButton
                    type="button"
                    class="btn btn-danger"
                    @click="OpenDeletePackages(item, studentDetails.Id)"
                  >
                    <CIcon name="cil-trash"
                  /></CButton>
                </td>
              </template>
            </CDataTable>
          </CCol>
        <CButton
            type="submit"
            class="p-2"
            color="info"
            @click="CreateAssignPackage(studentDetails.Id)"
            >Proceed</CButton
          >
            </CRow>
        </div>
    </div>

    <div v-if="StudentModal" class="popup-all backdrop-all">
        <div class="popup-all1 p-4">
            <CRow class="align-items-center mb-3">

                <div style="width:100%" class="text-right">
                    <img src="../assets/img/close.png" style="max-width: 30px; cursor: pointer;" @click="closePopupUpdateStudent" />
                </div>
            </CRow>
            <CRow>
          <br />
          <CCol sm="12">
            <CRow>
              <CCol sm="4"> Student Name </CCol>
              <CCol sm="8">
                <CInput type="text" v-model="StudentNames" />
              </CCol>

              <CCol sm="4"> Student Email </CCol>
              <CCol sm="8">
                <CInput type="text" v-model="StudentEmails" />
              </CCol>

              <CCol sm="4"> Parent Email</CCol>
              <CCol sm="8">
                <CInput type="text" v-model="ParentEmails" />
              </CCol>

              <CCol sm="4"> Parent Phone Number </CCol>
              <CCol sm="8">
                <CInput type="text" v-model="ParentPhoneNumbers" />
              </CCol>

              <CCol sm="4"> Grade</CCol>
              <CCol sm="8">
                <v-select
                  v-model="SelectedGradeNames"
                  :options="grades"
                  label="GradeName"
                  placeholder="--Please Select Grade--"
                ></v-select>
                <br />
              </CCol>

              <CCol sm="4"> Class Name</CCol>
              <CCol sm="8">
                <v-select
                  v-model="SelectedClassNames"
                  :options="classes"
                  label="Name"
                  placeholder="--Please Select Class--"
                ></v-select>
                <br />
              </CCol>

              <CCol sm="4"> Status</CCol>
              <CCol sm="8">
                <v-select
                  v-model="SelectedStatus"
                  :options="statuses"
                  label="name"
                  placeholder="--Please Select Status--"
                ></v-select>
                <br />
              </CCol>
            </CRow>
          </CCol>
            </CRow>
            <CButton
            type="submit"
            class="p-2"
            color="info"
            @click="UpdateStudent(studentDetails.Id)"
            >Proceed</CButton
          >
        </div>
    </div>

    <div v-if="InactiveModal" class="popup-all backdrop-all">
      <div class="popup-all1 p-4">
        <CRow class="align-items-center mb-3">
          <div style="width:100%" class="text-right">
            <img src="../assets/img/close.png" style="max-width: 30px; cursor: pointer;" @click="closePopupInactiveStudent" />
          </div>
        </CRow>
        <CRow>
          <br />
          <CCol sm="12">
            <div>
              Are you sure you want to inactive 
              {{ studentDetails.StudentRegInfo && studentDetails.StudentRegInfo.length > 0 ? studentDetails.StudentRegInfo[0].FullName : studentDetails.Name }}?
              <br />
            </div>
            <CButton
              type="submit"
              class="p-2 mt-4"
              color="info"
              @click="UpdateStudentStatus(studentDetails.Id)"
            >
              Proceed
            </CButton>
          </CCol>
        </CRow>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      students: [],
      currentPage: 1,
      pageSize: 10000, // Default page size
      totalPages: 0,
      Busy: false,
      searchQuery: "", // Holds the current search query
      user: {},
      StudentDetailModal: false,
      currentDate: new Date().toISOString().substring(0, 10),
      fieldsPackages: [{ key: "Name" }, { key: "Action" }],

      studentDetails: {},

      DiscountModal: false,
      Discount: "",

      AssignPackageModal: false,
      packages: [],
      studentpackages:[],
      selectedPackage: "",


      StudentModal: false,
      StudentNames: "",
      StudentEmails: "",
      ParentEmails: "",
      ParentPhoneNumbers: "",

      InactiveModal: false,

      check: {},

      showAllStatuses: false, // Switch state
      Busy: false, // API loading state

      gradesName: [],
      classes:[],
      SelectedGradeNames: {},
      SelectedClassNames: {},
      SelectedStatus:{},
      statuses:[
        {
          id:1,
          name:"active"

        },
        {
          id:2,
          name:"inactive"

        },

      ]

    };
  },
  watch: {
     
    showAllStatuses(newVal) {
            console.log("status changed to:", newVal);
            this.GetStudent(this.currentPage);
        },
    },
  computed: {
    // Compute the range of page numbers to display (only 5 at a time)
    visiblePageNumbers() {
      const pageNumbers = [];
      const range = 5;
      const halfRange = Math.floor(range / 2);

      let startPage = this.currentPage - halfRange;
      let endPage = this.currentPage + halfRange;

      if (startPage < 1) {
        startPage = 1;
        endPage = Math.min(range, this.totalPages);
      }

      if (endPage > this.totalPages) {
        endPage = this.totalPages;
        startPage = Math.max(1, this.totalPages - range + 1);
      }

      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
      }

      return pageNumbers;
    },
    filteredStudents() {
    if (!this.searchQuery) {
      return this.students;
    }
    return this.students.filter(student => {
      // Check if any package name contains the search query
      return student.Packages.some(packages => 
        packages.Name.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    });
  },
  },
  methods: {
    GetStudent(page) {
      const status = this.showAllStatuses ? 'All' : null;
      this.Busy = true;
      this.$API
        .get(this.$GetStudentTcByPaginate, {
          withCredentials: true,
          params: {
            pageNumber: page,
            pageSize: this.pageSize, // Include the dynamic page size
            search: this.searchQuery, // Include the search query in the API request
            status
          },
        })
        .then((response) => {
          this.students = response.data.Students;
          this.currentPage = response.data.CurrentPage;
          this.totalPages = response.data.TotalPages;
        })
        .catch((error) => {
          console.error("Error fetching students:", error);
        })
        .finally(() => {
          this.Busy = false;
        });
    },
    onSearch() {
      this.currentPage = 1; // Reset to the first page when searching
      this.GetStudent(this.currentPage);
    },
    onPageSizeChange() {
      this.currentPage = 1; // Reset to the first page when changing page size
      this.GetStudent(this.currentPage);
    },
    SessionUserIdNo() {
      return this.$API
        .get(this.$LoginUserDetailAdmin, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetCheckTc(this.user.tuitioncenter);
          }
        });
    },
    GetCheckTc(tuitioncenter) {
      return this.$API
        .get(this.$GetCheckTcPackage + "?TuitionCenterId=" + tuitioncenter, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.check = response.data;
          }
        });
    },
    getPicChild(item) {
      return "https://pickiddo.com" + item.profileImagePath;
    },
    async GetGrade() {
      this.$API
        .get(this.$ListGrade, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.grades = response.data;
          }
        });
    },
    GetClass() {
      this.$API
        .get(this.$ListClassTc, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.classes = response.data;
          }
        });
    },

    OpenStudentModal(item) {
      this.StudentId = item.Id;

      this.$API
        .get(this.$StudentDetailByIdAuthorize + "?id=" + this.StudentId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.studentDetails = response.data;
          }
        });
        this.$API
        .get(this.$ListGrade, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.grades = response.data;
          }
        });
      this.StudentDetailModal = true;
    },
    SetupSelectedOption() {
      this.SelectedGradeNames = _.find(this.grades, {
        GradeName: this.Grades,
      });
      this.SelectedClassNames = _.find(this.classes, {
        Name: this.ClassNames,
      });

      this.SelectedStudent = _.find(this.students, {
        Name: this.StudentNames,
      });

      this.SelectedStatus = _.find(this.statuses, {
        name: this.Status,
      });
    },
    closePopupStudent()
    {
      this.StudentDetailModal = false;

    },
    OpenDiscountModal(item) {
      this.StudentId = item.Id;

      this.$API
        .get(this.$StudentDetailByIdAuthorize + "?id=" + this.StudentId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.studentDetails = response.data;
          }
        });
      this.DiscountModal = true;
    },
    closePopupDiscount()
    {
      this.DiscountModal = false;

    },
    UpdateDiscount: function () {
      const formData = new FormData();
      formData.append("Id", this.StudentId);
      formData.append("Discount", this.Discount);

      return this.$API
        .post(this.$UpdateDiscount, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.DiscountModal = false;
            this.GetStudent(this.currentPage); 
            this.Discount = "";
            this.$dialog.alert("Success saved").then(function () {});
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to update package ").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },
    OpenAssignPackageModal(item) {
      this.StudentId = item.Id;

      this.$API
        .get(this.$StudentDetailByIdAuthorize + "?id=" + this.StudentId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.studentDetails = response.data;
          }
        });

      this.$API
        .get(this.$ViewPackage, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            //this.Busy = false;
            this.packages = response.data;
          }
        });

      this.$API
        .get(this.$GetListStudentPackage + "?manualId=" + this.StudentId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.studentpackages = response.data;
          }
        });

      this.AssignPackageModal = true;
    },
    closePopupPackage()
    {
      this.AssignPackageModal = false;
    },
    async CreateAssignPackage() {
      const formData = new FormData();

      formData.append("ManualStudentId", this.StudentId);
      formData.append("TuitionPackageId", this.selectedPackage.Id);

      return this.$API
        .post(this.$InsertAssignStudentPackage, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
          
            this.GetStudent(this.currentPage);
            this.GetPackageManualStudent(this.StudentId);
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to save ").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },
    GetPackageManualStudent(Id) {
      return this.$API
        .get(this.$GetListStudentPackage + "?manualId=" + Id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            // this.Busy = false;
            this.studentpackages = response.data;
          }
        });
    },
    OpenDeletePackages(item, Id) {
      const formData = new FormData();

      formData.append("Id", item.Id);

      return this.$API
        .post(this.$DeleteStudentPackage, formData, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;

          if (response.status == 200) {
            this.GetStudent(this.currentPage);
            this.GetPackageManualStudent(this.StudentId);

            // this.AssignPackageModal = false;
          } else console.log("Error Deleting");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    OpenUpdateStudent(item) {
      this.StudentId = item.Id;

    

      this.$API
        .get(this.$GetRateType, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.rates = response.data;
          }
        });

      this.$API
        .get(this.$StudentDetailByIdAuthorize + "?id=" + this.StudentId, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;
          if (response.status == 200 && this.info != null) {
            this.StudentNames = this.info.Name;
            this.StudentEmails = this.info.StudentEmail;
            this.ParentNames = this.info.ParentName;
            this.ParentEmails = this.info.ParentEmail;
            this.ParentEmailPrevious = this.info.ParentEmail;
            this.ParentPhoneNumbers = this.info.ParentPhoneNumber;
            this.Grades = this.info.Grade;
            this.ClassNames = this.info.Class;
            this.Status = this.info.Status;

            this.SetupSelectedOption();
          }
        });
      this.StudentModal = true;
    },
    closePopupUpdateStudent()
    {
      this.StudentModal = false;

    },
    UpdateStudent: function () {
      const formData = new FormData();
      formData.append("Id", this.StudentId);
      formData.append("Name", this.StudentNames);
      formData.append("StudentEmail", this.StudentEmails);
      formData.append("ParentEmail", this.ParentEmails);
      formData.append("ParentEmailPrevious", this.ParentEmailPrevious);
      formData.append("ParentPhoneNumber", this.ParentPhoneNumbers);
      if (this.SelectedGradeNames?.GradeName) {
    formData.append("Grade", this.SelectedGradeNames.GradeName);
}
if (this.SelectedClassNames?.Name) {
    formData.append("ClassName", this.SelectedClassNames.Name);
} 
      formData.append("Status", this.SelectedStatus.name);

      return this.$API
        .post(this.$UpdateManualStudent, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.StudentModal = false;
            this.GetStudent(this.currentPage);
            this.$dialog.alert("Success saved").then(function () {});
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to update ").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },
    OpenInactiveModal(item) {
      this.StudentId = item.Id;

      this.$API
        .get(this.$StudentDetailByIdAuthorize + "?id=" + this.StudentId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.studentDetails = response.data;
          }
        });
      this.InactiveModal = true;
    },
    closePopupInactiveStudent()
    {
      this.InactiveModal = false;

    },
    UpdateStudentStatus: function () {
      const formData = new FormData();
      formData.append("Id", this.StudentId);
      formData.append("Status", "inactive");

      return this.$API
        .post(this.$UpdateStatusStudent, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.InactiveModal = false;
            this.GetStudent(this.currentPage);
            this.$dialog.alert("Success saved").then(function () {});
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to update ").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },
    downloadCSV() {
    if (!this.students || this.students.length === 0) {
      this.$dialog.alert("No students to export");
      return;
    }

    // Define CSV headers
    const headers = [
      "ID",
      "Name",
      "Parent Name",
      "Parent Email",
      "Grade",
      "Class",
      "Phone",
      "Status",
      "Packages",
      "Subjects",
      "Discount",
      "Total Fee"
    ];

    // Map student data into rows
    const rows = this.students.map(student => {
      const packages = student.Packages.map(p => `${p.Name} (RM ${p.StudentFee})`).join(" | ");
      const subjects = student.Packages.flatMap(p => p.Subjects.map(s => `${s.Name} (Teacher: ${s.Teacher})`)).join(" | ");

      return [
        student.Id,
        student.Name,
        student.ParentName,
        student.ParentEmail,
        student.Grade,
        student.Class,
        student.Phone,
        student.Status,
        packages,
        subjects,
        student.Discount || 0,
        (student.TotalFee - (student.Discount || 0))
      ];
    });

    // Convert to CSV string
    const csvContent = [headers, ...rows].map(e => e.map(v => `"${v}"`).join(",")).join("\n");

    // Create a blob and trigger download
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", `students_${new Date().toISOString().slice(0,10)}.csv`);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  },
  mounted() {
    this.GetStudent(this.currentPage);
    this.SessionUserIdNo();
    this.GetGrade();
    this.GetClass();
  },
  
};
</script>

<style scoped>
.search-container {
  margin-bottom: 20px;
}
.page-size-selector {
  margin-bottom: 20px;
}
input[type="text"] {
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 4px;
}
select {
  padding: 5px;
  margin-left: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.pagination {
  display: flex;
  justify-content: left;
  align-items: left;
}

.pagination button {
  padding: 5px 10px;
  margin: 0 3px;
  cursor: pointer;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.pagination button.active {
  background: linear-gradient(286.01deg, #5BC4FF 7.93%, #0085FF 96.74%);
  color: white;
}

.pagination button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.pagination button:hover {
  background-color: #ddd;
}
</style>